import React, { useState, useRef, useEffect } from "react";
import { FRONTEND_URL } from "../../config/axios";
import "./UserProfileMenu.css";

const UserProfileMenu = () => {
  const [open, setOpen] = useState(false);
  const [imgError, setImgError] = useState(false);
  const menuRef = useRef(null);

  const name = sessionStorage.getItem("dpr_name") || sessionStorage.getItem("name") || "User";
  const email = sessionStorage.getItem("dpr_email") || sessionStorage.getItem("email") || "";
  const role = sessionStorage.getItem("dpr_role") || sessionStorage.getItem("role") || "";
  const rawProfilepic = sessionStorage.getItem("profilepic");

  const profilepic =
    rawProfilepic && rawProfilepic.startsWith("http") && !imgError ? rawProfilepic : null;

  const initials = name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    window.location = FRONTEND_URL;
  };

  return (
    <div className="upm-wrapper" ref={menuRef}>
      <button className="upm-trigger" onClick={() => setOpen((o) => !o)}>
        {profilepic ? (
          <img
            src={profilepic}
            alt=""
            onError={() => setImgError(true)}
            className="upm-avatar-sm"
          />
        ) : (
          <div className="upm-avatar-sm upm-avatar-initials">{initials}</div>
        )}
        <span className="upm-name">{name}</span>
      </button>

      {open && (
        <div className="upm-dropdown">
          <div className="upm-header">
            {profilepic ? (
              <img src={profilepic} alt="" className="upm-avatar-lg" />
            ) : (
              <div className="upm-avatar-lg upm-avatar-initials">{initials}</div>
            )}
            <div className="upm-info">
              <div className="upm-fullname">{name}</div>
              {role && <div className="upm-role">{role}</div>}
              <div className="upm-email">{email}</div>
            </div>
          </div>

          <button className="upm-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserProfileMenu;